import React from 'react';
import Hero from './components/Hero';
import Countdown from './components/Countdown';
import EventInfo from './components/EventInfo';
import Gallery from './components/gallery/Gallery';
import GuestInfo from './components/GuestInfo';

import Instagram from './components/Instagram';
import CeremonyAndParty from './components/CeremonyAndParty';

import WaveDivider from './components/dividers/WaveDivider';
import CurvyDivider from './components/dividers/CurvyDivider';
import OrnamentalDivider from './components/dividers/OrnamentalDivider';
import TriangleDivider from './components/dividers/TriangleDivider';
import LeafDivider from './components/dividers/LeafDivider';

// Definimos los colores en tonos dorados y beige
const colors = {
  transparent: 'transparent',
  white: '#ffffff',
  gold: '#D4AF37',      // dorado clásico
  champagne: '#F7E7CE',  // champagne claro
  sand: '#E6D5AC',      // arena dorada
  beige: '#F5E6CC',     // beige suave
  ivory: '#FFFFF0',     // marfil cálido
  wheat: '#F5DEB3',     // trigo dorado
  pearl: '#EAE0C8',     // perla dorada
  cream: '#FFEFD5'      // crema melocotón
};

function App() {
  return (
    <div className="w-full min-h-screen" style={{ backgroundColor: colors.champagne }}>
      <Hero />
      <div style={{ backgroundColor: colors.ivory }} className="pt-8">
        <Countdown />
        <LeafDivider fromColor={colors.ivory} toColor={colors.sand} />
      </div>
      <div style={{ backgroundColor: colors.sand }} className="pt-8">
        <CeremonyAndParty />
        <TriangleDivider fromColor={colors.sand} toColor={colors.beige} />
      </div>
      <div style={{ backgroundColor: colors.beige }} className="pt-8">
        <EventInfo />
        <OrnamentalDivider fromColor={colors.beige} toColor={colors.wheat} />
      </div>
      <div style={{ backgroundColor: colors.wheat }} className="pt-8">
        <GuestInfo />
        <WaveDivider fromColor={colors.wheat} toColor={colors.wheat} />
      </div>
      <div style={{ backgroundColor: colors.pearl }} className="pt-8">

        <CurvyDivider fromColor={colors.pearl} toColor={colors.gold} />
      </div>
      <div style={{ backgroundColor: colors.gold }}>
        <Gallery />
        <OrnamentalDivider fromColor={colors.gold} toColor={colors.cream} />
      </div>
      <div style={{ backgroundColor: colors.cream }}>

      </div>
    </div>
  );
}

export default App;
